export default __webpack_public_path__ + "static/media/December2012.7fd7c19e.png";